import RemainingBudgetSummary from './RemainingBudgetSummary';

export default RemainingBudgetSummary;
